<template>
  <b-container>
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="form-row">
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp1"
            label-cols="2"
            label="Scheme"
            label-size="sm"
            label-for="ipLoanType"
          >
            <b-select
              id="ipLoanType"
              class="form-control"
              value-field="LoanType"
              size="sm"
              text-field="SchemeName"
              :options="schemes"
              v-model="form.LoanType"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="District"
            label-size="sm"
            label-for="ipDistrict"
          >
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              size="sm"
              :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
              v-model="form.DistrictID"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp3"
            label-cols="2"
            label="Bank"
            label-size="sm"
            label-for="ipAPSts"
          >
            <b-select
              id="ipAPSts"
              class="form-control"
              :options="banks"
              value-field="BankID"
              text-field="BankName"
              required
              size="sm"
              v-model="form.BankID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp4"
            label-cols="4"
            label="Application No"
            label-size="sm"
            label-for="ipAppNum"
          >
            <b-form-input
              type="text"
              size="sm"
              id="ipAppNum"
              v-model="form.LoanApplicationNo"
            />
          </b-form-group>
        </b-col>
      </div>
      <b-row>
        <b-col class="mt-2" md="2">
          <b-form-group
            id="grp14"
            label-cols="3"
            label="LOI No"
            label-size="sm"
            label-for="ipLoiNum"
          >
            <b-form-input
              type="text"
              size="sm"
              id="ipLoiNum"
              v-model="form.LOINumber"
            />
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <b-form-group
            id="grp13"
            label-cols="4"
            label="Claim Date"
            label-size="sm"
            label-for="ipAPDt"
          >
            <date-picker
              v-model="UpdateDate"
              format="DD-MM-YYYY"
              id="ipAPDt"
              lang="en"
              range
              size="small"
              style="width: 220px"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="Claim Status"
            label-size="sm"
            label-for="ipDistrict2"
          >
            <b-select
              id="ipDistrict2"
              :options="approvalStatus"
              value-field="Id"
              text-field="ApplicationStatus"
              size="sm"
              v-model="form.ClaimStatus"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="2">
          <b-form-group
            id="grpOwner"
            label-cols="3"
            label="Owner"
            label-size="sm"
            label-for="ipowner"
          >
            <b-select
              id="ipowner"
              :options="statusOwner"
              value-field="value"
              text-field="text"
              size="sm"
              v-model="form.StatusOwner"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-0">
          <b-button type="submit" size="sm" variant="primary" class="my-2"
            :disabled="isLoadingM"
            >{{ isLoadingM ? 'Loading...' : 'Search' }}</b-button
          >
          <b-button type="reset" size="sm" variant="secondary" class="my-2"
            :disabled="isLoadingM"
            >Reset</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="isLoadingM">
        <b-col>
          <Spinner size="32" message="Loading..." v-if="isLoadingM"></Spinner>
          <b-alert
            :show="showDismissibleAlertM"
            dismissible
            @dismissed="showDismissibleAlertM = false"
            :variant="variantM"
            >{{ alertTextM }}</b-alert
          >
        </b-col>
      </b-row>
    </b-form>
    <hr />
    <!-- <b-form @submit="onSubmit" @reset="onReset">
            <div class="form-row" >
                <div class="form-group col-md-5">
                    <label size="sm" label-cols="4" for="ipLoanType">Claim Paid Status</label>
                    <b-select id="ipLoanType" class="form-control" value-field="Id" size="sm"
                        text-field="ApplicationStatus" :options="paymentStatus" v-model="form.ClaimPaidStatus">
                    </b-select>
                </div>
                <div class="form-group col-md-4">
                    <label for="ipDistrict">District</label>
                    <b-select id="ipDistrict"
                        :options="districts"
                        value-field="DistID"
                        text-field="DistName"
                        required
                        size="sm"
                        v-model="form.DistrictID"
                        class="form-control">
                    </b-select>
                </div>
                <div class="form-group col-md-3">
                    <label for="ipAPSts">Status</label>
                    <b-select id="ipAPSts" class="form-control" :options="approvalStatus"
                        value-field="Id"
                        text-field="ApplicationStatus"
                        required
                        size="sm"
                        v-model="form.ClaimStatus">
                    </b-select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="inputCity">Application No</label>
                    <input type="text" class="form-control" id="inputCity" v-model="form.ApplicationNo">
                </div>
                <div class="form-group col-md-4">
                    <label for="ipMobile">Mobile No</label>
                    <input type="text" class="form-control" id="ipMobile" v-model="form.MobileNo">
                </div>
                <div class="form-group col-md-2" style="valign:bottom">
                    <b-button type="submit" size="sm" variant="primary" style="margin-top:35px">Search</b-button>
                </div>


            </div>


    </b-form>-->

    <b-row>
      <b-col></b-col>
      <b-col md="4"></b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            v-model="filter"
            placeholder="Type to Search"
            size="sm"
          />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm"
              >Clear</b-btn
            >
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col></b-col>
      <b-col md="4">
        <b-form-group
          horizontal
          label="Sort"
          class="mb-0"
          label-size="sm"
          label-cols="1"
        >
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <!-- General Export Buttons - visible for all users -->
    <div class="row mb-2" v-if="claims.length > 0" style="margin-top:10px;">
      <div class="col-12">
        <button type="button" class="btn btn-success btn-sm mr-2" @click="downloadExcel('All')">
          <i class="fa fa-file-excel"></i> Export to Excel
        </button>
        <!-- <button v-if="form.StatusOwner === 'ToBePaid' && (RoleID === 5 || RoleID === 4)" type="button" class="btn btn-warning btn-sm mr-2" @click="confirmAndExport('excel')">
          <i class="fa fa-file-excel"></i> Export & Mark as Paid
        </button> -->
        <button v-if="form.StatusOwner === 'ToBePaid' && (RoleID === 5 || RoleID === 4)" type="button" class="btn btn-warning btn-sm" @click="confirmAndExport('text')">
          <i class="fa fa-file-alt"></i> Export & Mark as Paid (Text)
        </button>
      </div>
    </div>
    <b-row>
      <b-col style="min-width: 0; overflow: hidden;">
        <div style="overflow-x: auto; width: 100%;">
          <div v-if="isLoadingM" class="text-center py-4">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
            <div class="mt-2">Loading claims...</div>
          </div>
          <b-table
            v-else
            show-empty
            selectable
            responsive="true"
            select-mode="single"
            head-variant="dark"
            empty-text="No Claim available for the query."
            stacked="md"
            bordered
            striped
            :items="claims"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-compare="compareClaimSubmission"
            @filtered="onFiltered"
            @row-selected="onRowSelected"
            style="font-size: 12px; width: 100%; margin-left: 0"
          >
            <template v-slot:cell(SL)="row">
              {{ row.index + 1 }}
            </template>

            <template v-slot:cell(DisbursalDate)="row">
              <span>{{ getDisbursalDateText(row.item) }}</span>
            </template>

            <!-- <template v-slot:cell(selected)="{ rowSelected }"> -->

            <template v-slot:cell(ApprovalLog)="row">
              <span v-if="row.item._logLoading" class="text-muted" style="font-size:11px">...</span>
              <span v-else-if="row.item.ApprovalLog" style="white-space:pre-line;font-size:11px">{{ row.item.ApprovalLog }}</span>
            </template>

            <template v-slot:cell(action)="row">
              <b-button
                size="sm"
                @click.stop="viewDisbursal(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="success"
                v-b-tooltip.hover
                title="View Details"
                >View</b-button
              >
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group
          horizontal
          label="Per page"
          class="mb-0"
          label-size="sm"
          :label-cols="6"
        >
          <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalClaim"
        size="xl"
        :title="'Claim Details' + (selectedApplication && selectedApplication.FullName ? ' — ' + selectedApplication.FullName : '')"
        scrollable
        hide-footer
      >
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Claim Details">
              <b-container>
                <!-- <b-row class="mb-2">
                  <b-col md="4">
                    <b style="font-size: 0.875rem">Full Name:</b>
                    {{ selectedApplication.FullName }}
                  </b-col>
                  <b-col style="font-size: 0.875rem" md="3">
                    <b>Adhar No:</b>
                    {{ selectedApplication.AdharNo }}
                  </b-col>
                </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="8">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Applicant Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Full Name:</b
                                    >
                                    {{ selectedApplication.FullName }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem">Adhar No:</b>
                                    {{ selectedApplication.AdharNo }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>

                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Loan Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Loan Bank:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.LoanBank
                                    }}</span>
                                  </td>
                                  <td colspan="3">
                                    <b style="font-size: 0.875rem"
                                      >Loan Bank Branch:</b
                                    >
                                    {{ selectedApplication.LoanBranch }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Sanction Amount(Rs):</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.SanctionAmount
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Disbursed Amount(Rs):</b
                                    >
                                    {{ selectedApplication.DisbursedAmount }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem">ROI(%):</b>
                                    {{ selectedApplication.ROI }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Tenure(Months):</b
                                    >
                                    {{ selectedApplication.LoanTenure }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>

                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Loan Bank:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.LoanBank
                    }}</span>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Loan Bank Branch:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.LoanBranch
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="my-3" style="background-color: orange">
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>Sanction Amount(Rs)</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.SanctionAmount
                  }}</b-col>
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>Disbursed Amount(Rs)</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.DisbursedAmount
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>ROI</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.ROI
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>LoanTenure</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.LoanTenure
                  }}</b-col>
                </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Bank Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem">Bank:</b>
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.BankName
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Loan Bank Branch:</b
                                    >
                                    {{ selectedApplication.BranchName }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Account No:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.BankAccountNo
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Total EMI Paid:</b
                                    >
                                    {{ selectedApplication.TotalEMIPaid }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Applicant Bank:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.BankName
                    }}</span>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Applicant Branch:</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.BranchName
                    }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Applicant Account No :</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.BankAccountNo
                    }}</span>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Total EMI Paid :</b>
                    <span style="font-size: 0.875rem">{{
                      selectedApplication.TotalEMIPaid
                    }}</span>
                  </b-col>
                </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              EMI Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Paid Date:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.EMIPaidDate
                                        | formatDate
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Paid Amount:</b
                                    >
                                    {{ selectedApplication.EMIPaidAmt }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Principal Amt:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.PrincipalAmt
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Interest Amt:</b
                                    >
                                    {{ selectedApplication.InterestAmt }}
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Penalty/Other Amt:</b
                                    >
                                    {{ selectedApplication.PenaltyCharges }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >EMI Paid Proof:</b
                                    >
                                    <a
                                      target="_blank"
                                      :href="
                                        getImgUrl(
                                          selectedApplication.UploadEMIPaidProof
                                        )
                                      "
                                      >View</a
                                    >
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Business Photo:</b
                                    >
                                    <span
                                      v-if="
                                        selectedApplication.UploadBusinessPhoto ==
                                          '' ||
                                        !selectedApplication.UploadBusinessPhoto
                                      "
                                      >Not Uploaded</span
                                    >
                                    <a
                                      v-else
                                      target="_blank"
                                      :href="
                                        getImgUrl(
                                          selectedApplication.UploadBusinessPhoto
                                        )
                                      "
                                      >View</a
                                    >
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <!-- <b-row class="mb-2 mt-4" style="background-color: yellow">
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>EMI Paid Date</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem" md="2">{{
                    selectedApplication.EMIPaidDate | formatDate
                  }}</b-col>
                  <b-col style="font-size: 0.875rem" md="2">
                    <b>EMI Paid Amt</b>
                  </b-col>
                  <b-col md="2" style="font-size: 0.875rem">{{
                    selectedApplication.EMIPaidAmt
                  }}</b-col>
                </b-row> -->
                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Principal Amt</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.PrincipalAmt
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Interest Amt</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.InterestAmt
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Penalty Charges</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.PenaltyCharges
                  }}</b-col>
                </b-row> -->
                <!-- <b-row class="mb-2"> -->
                <!-- <b-col style="font-size:0.875rem"><b>UploadBankStmt</b></b-col><b-col style="font-size:0.875rem">{{selectedApplication.UploadBankStmt}}</b-col> -->
                <!-- <b-col style="font-size: 0.875rem">
                    <b>EMI Paid Proof</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <a
                      target="_blank"
                      :href="getImgUrl(selectedApplication.UploadEMIPaidProof)"
                      >View</a
                    >
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Business Photo</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">
                    <span
                      v-if="
                        selectedApplication.UploadBusinessPhoto == '' ||
                        !selectedApplication.UploadBusinessPhoto
                      "
                      >Not Uploaded</span
                    >
                    <a
                      v-else
                      target="_blank"
                      :href="getImgUrl(selectedApplication.UploadBusinessPhoto)"
                      >View</a
                    >
                  </b-col> -->
                <!-- </b-row> -->
                <div class="reg-form-box">
                  <div class="reg-form-body">
                    <b-container class="bv-example-row">
                      <b-row>
                        <b-col cols="12">
                          <b-container class="bv-example-row">
                            <h5 class="reg-form-title text-primary">
                              Claim Details
                            </h5>

                            <table
                              class="profile-table table-3x"
                              style="margin-left: 0"
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Approval Status:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.ClaimStatus
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Payment Status:</b
                                    >
                                    {{ selectedApplication.ClaimPaymentStatus }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Claim Amount:</b
                                    >
                                    <span style="font-size: 0.875rem">{{
                                      selectedApplication.InterestAmt
                                    }}</span>
                                  </td>
                                  <td>
                                    <b style="font-size: 0.875rem"
                                      >Paid Amount:</b
                                    >
                                    {{ selectedApplication.TotalPaidClaim }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-container>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                </div>
                <!-- <b-row class="mb-2">
                  <b-col style="font-size: 0.875rem">
                    <b>Claim Status</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.ClaimStatus
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Claim Payment Status</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.ClaimPaymentStatus
                  }}</b-col>
                </b-row> -->
                <!-- <b-row class="mb-2"> -->
                <!-- <b-col style="font-size: 0.875rem">
                    <b>Total Claim Amount</b>
                  </b-col> -->
                <!-- <b-col style="font-size:0.875rem">{{selectedApplication.TotalClaimAmount}}</b-col> -->
                <!-- <b-col style="font-size: 0.875rem">{{
                    selectedApplication.InterestAmt
                  }}</b-col>
                  <b-col style="font-size: 0.875rem">
                    <b>Total Paid Claim</b>
                  </b-col>
                  <b-col style="font-size: 0.875rem">{{
                    selectedApplication.TotalPaidClaim
                  }}</b-col>
                </b-row> -->
                <hr />
                <div class="reg-form-box">
                  <Spinner
                    size="32"
                    message="Loading..."
                    v-if="isLoading"
                  ></Spinner>
                  <b-alert
                    :show="showDismissibleAlert"
                    dismissible
                    @dismissed="showDismissibleAlert = false"
                    :variant="variant"
                    >{{ alertText }}</b-alert
                  >
                  <b-form @submit="onSubmitApprove" v-if="showApproval">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <b-form-group
                          id="igAprvAmt"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Approved Amount"
                          label-for="ipAprvAmt"
                          label-size="sm"
                        >
                          <b-form-input
                            type="text"
                            size="sm"
                            id="ipAprvAmt"
                            v-model="formclm.ApprovedAmount"
                            @input="calculateReject"
                          />
                        </b-form-group>
                      </div>
                      <div class="form-group col-md-6">
                        <b-form-group
                          id="igRejectAmt"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Rejected Amount"
                          label-for="ipRejectAmt"
                          label-size="sm"
                        >
                          <b-form-input
                            type="text"
                            size="sm"
                            id="ipRejectAmt"
                            disabled
                            v-model="formclm.RejectedAmount"
                            @input="calculateApprove"
                          />
                        </b-form-group>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <b-form-group
                          id="fieldset-horizontal"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Approve Claim"
                          label-for="ipAprv"
                          label-size="sm"
                        >
                          <b-select
                            id="ipAprv"
                            :options="ApprovalStatus"
                            value-field="StatusID"
                            text-field="Status"
                            required
                            size="sm"
                            @change.native="checkReject"
                            v-model="formclm.ClaimStatusID"
                            class="form-control"
                          ></b-select>
                        </b-form-group>
                      </div>

                      <div class="form-group col-md-6">
                        <b-form-group
                          id="fieldset-horizontal2"
                          label-cols-sm="4"
                          label-cols-lg="3"
                          label="Reject Reason"
                          label-for="ipReason"
                          label-size="sm"
                        >
                          <b-select
                            id="ipReason"
                            :options="RejectReasons"
                            value-field="RejectedID"
                            text-field="RejectedTypeName"
                            required
                            size="sm"
                            :disabled="!isReject"
                            v-model="formclm.RejectReason"
                            class="form-control"
                          ></b-select>
                        </b-form-group>
                      </div>
                      <div class="form-group col-md-4"></div>
                    </div>
                    <div class="form-row">
                      <div
                        class="form-group col-md-12"
                        style="text-align: left"
                      >
                        <b-form-group
                          id="fieldset-horizontal"
                          label-cols-sm="4"
                          label-cols-md="1"
                          label="Remarks"
                          label-for="ipRemarks"
                          label-size="sm"
                        >
                          <b-form-textarea
                            id="ipRemarks"
                            v-model="formclm.Remarks"
                            required
                            size="sm"
                            rows="2,"
                            max-rows="4"
                            placeholder="Remarks"
                          ></b-form-textarea>
                        </b-form-group>
                      </div>
                    </div>
                    <b-col style="text-align: center">
                      <b-button type="submit" variant="primary"
                        >Submit</b-button
                      >
                    </b-col>
                  </b-form>
                  <b-alert v-else :show="true" variant="info">
                    No approval action is currently available for this claim at your role/stage.
                  </b-alert>
                </div>
                <b-row>
                  <b-col cols="10" offset="1">
                    <h5 class="reg-form-title text-primary">
                      Approval History
                    </h5>
                    <b-table
                      show-empty
                      selectable
                      select-mode="multi"
                      head-variant="dark"
                      empty-text="No Applications available."
                      stacked="md"
                      bordered
                      striped
                      :items="approvalRemarks"
                      :fields="approvalFields"
                      variant="dark"
                      style="font-size: 12px"
                    ></b-table>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
            <b-tab title="LOI">
              <l-o-i-details
                :UserID="this.selectedApplication.UserID"
                :ApplicationID="this.selectedApplication.LoanApplicationID"
                :Loantype="this.selectedApplication.LoanType"
              ></l-o-i-details>
            </b-tab>
            <b-tab title="Sanction Letter">
              <sanction-details
                :UserID="this.selectedApplication.UserID"
              ></sanction-details>
            </b-tab>
            <b-tab title="Disbursals">
              <disbursal-details
                :UserID="this.selectedApplication.UserID" :LoanType="this.form.LoanType"
              ></disbursal-details>
            </b-tab>
            <b-tabs v-model="activeTab" card>

</b-tabs>

            <b-tab title="Edit Docs">
              <document-upload
                :UserID="this.selectedApplication.UserID"
                :Stage="stage"
                :Id="this.selectedApplication.ClaimEMIID"
              ></document-upload>
            </b-tab>
            <b-tab title="Profile">
              <profile-approval
                :UserID="this.selectedApplication.UserID"
                :ApplicationStatus="1"
              ></profile-approval>
            </b-tab>
            <b-tab title="Claim History">
              <claim-list-admin
                :ClaimUserID="this.selectedApplication.UserID"
              ></claim-list-admin>
            </b-tab>


  <b-tab title="EMI Schedule">
    <e-m-i-schedule
      :ApplicationID="this.selectedApplication.LoanApplicationID"
    ></e-m-i-schedule>
  </b-tab>
          </b-tabs>
        </b-card>
      </b-modal>
    </div>
  </b-container>
</template>

<script>import { protectedDocumentUrl } from "@/services/tenantDocuments";

import apis from "@/apis";
import { compareClaimSubmission, sortClaimsFifo } from "@/services/claimOrder";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Formatter from "@/Formatter";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import DisbursalDetails from "./ClaimComponents/DisbursalDetails";
import EMISchedule from "./ClaimComponents/EMISchedule";
import LOIDetails from "./ClaimComponents/LOIDetails";
import SanctionDetails from "./ClaimComponents/SanctionDetails";
import ProfileApproval from "@/components/Admin/ViewPersonalDetailsProfile";
import GroupProfileApproval from "@/components/Admin/ViewGroupDetailsProfile";
import XLSX from "xlsx";
import DocumentUpload from "@/components/ClaimApproval/DocumentUpload";
import ClaimListAdmin from "@/components/ClaimUpload/ClaimListAdmin"

export default {
  components: {
    Spinner,
    DatePicker,
    SanctionDetails,
    DisbursalDetails,
    EMISchedule,
    LOIDetails,
    DocumentUpload,
    ProfileApproval,
    ClaimListAdmin
  },
  data() {
    return {
      show: false,
      showsts: false,
      showxls: false,
      showExportButtons: false,
      showApproval: false,
      statusOwner: [
        { value: "All", text: "All" },
        { value: "Accounts", text: "DM" },
        { value: "Auditor", text: "RM" },
        { value: "DGM", text: "PM" },
        { value: "GM", text: "GM" },
        { value: "MD", text: "MD" },
        { value: "ToBePaid", text: "ToBePaid" },
        { value: "Paid", text: "Paid" },
        { value: "Applicant", text: "Applicant" },
        { value: "Rejected", text: "Rejected" },
      ],
      isReject: false,
      modalInfo: "",
      UpdateDate: [null, null],
      districts: [],
      schemes: [],
      approvalStatus: [],
      paymentStatus: [],
      claims: [],
      bscReport: "",
      bscReportPath: "",
      banks: [],
      fields: [
        { key: "SL", label: "SrNo" },
        { key: "FullName", label: "Full Name", sortable: true },
        { key: "DistrictName", label: "District", sortable: true },
        { key: "SanctionAmount", label: "Sanction Amount", sortable: true },
        { key: "DisbursedAmount", label: "Disbursed Amount", sortable: true },
        {
          key: "DisbursalDate",
          label: "Disbursal Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        { key: "TotalEMIPaid", label: "Total EMI Paid", sortable: true },
        { key: "ROI", label: "ROI%", sortable: true },
        { key: "LoanTenure", label: "Tenure (months)", sortable: true },
        {
          key: "EMIPaidDate",
          label: "EMI Paid Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        { key: "EMIPaidAmt", label: "EMI Paid Amt", sortable: true },
        { key: "PrincipalAmt", label: "Principal Amt", sortable: true },
        { key: "InterestAmt", label: "Interest Amt", sortable: true },
        { key: "PenaltyCharges", label: "Penalty Charges", sortable: true },
        { key: "ClaimStatus", label: "Claim Status", sortable: true },
        {
          key: "ClaimPaymentStatus",
          label: "Payment Status",
          sortable: true,
        },
        {
          key: "UpdatedDate",
          label: "Claim Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        {
          key: "TotalClaimAmount",
          label: "Total Claim Amount",
          sortable: true,
        },
        {
          key: "ApprovedAmount",
          label: "Approved Amount",
          sortable: true,
        },
        { key: "TotalPaidClaim", label: "Total Paid Claim", sortable: true },
        { key: "ApprovalLog", label: "Approval Log", sortable: false },

        { key: "action", label: "View" },
      ],
      selected: [],
      form: {
        DistrictID: "00000000-0000-0000-0000-000000000000",
        BankID: "00000000-0000-0000-0000-000000000000",
        ClaimStatus: 0,
        ClaimPaidStatus: 0,
        LoanApplicationNo: null,
        LOINumber: null,
        UserLoginID: null,
        RecoStatus: 0,
        ClaimStartDate: null,
        ClaimEndDate: null,
        LoanType: 1,
        StatusOwner: "All",
      },
      formclm: {
        ClaimStatusID: 1,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ClaimID: "",
        ApprovedAmount: 0,
        RejectedAmount: 0,
      },
      RoleID: 0,
      ApprovalStatusAll: [],
      ApprovalStatus: [
        { StatusID: 1, Status: "Pending" },
        { StatusID: 2, Status: "Verified" },
        { StatusID: 6, Status: "Rejected" },
      ],
      approvalRemarks: [],
      approvalFields: [
        "ClaimStatus",
        "RejectionReason",
        "ApprovedAmount",
        "RejectedAmount",
        { key: "RejectRemarks", label: "Remarks" },
        { key: "LogDate", formatter: "convertDateFormat" },
        "ApproverName",
      ],
      RejectReasons: [],

      selectedApplication: {
        UserID: "00000000-0000-0000-0000-000000000000",
      },
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions: [50,60,70,80,90,100],
      sortBy: "UpdatedDate",
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      showDismissibleAlertM: false,
      variantM: "success",
      alertTextM: "",
      isLoadingM: false,
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0,
      },
      stage: 4,
      activeTab: 0,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    },
    hasExportableClaims() {
      return this.claims && this.claims.length > 0;
    },
  },
  filters: {
    formatDate(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
  },
  methods: {
    compareClaimSubmission,
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    resolveDisbursalDate(claim) {
      if (!claim || typeof claim !== "object") return null;

      var directDate =
        claim.DisbursalDate ||
        claim.DisbursementDate ||
        claim.DisbursedDate ||
        claim.LoanDisbursalDate ||
        claim.disbursalDate ||
        claim.disbursementDate ||
        claim.disbursedDate ||
        claim.loanDisbursalDate ||
        claim.DisbursalDt ||
        claim.DisbursementDt ||
        null;

      if (directDate) {
        return directDate;
      }

      var dynamicKey = Object.keys(claim).find(function (k) {
        return /disburs/i.test(k) && /date|dt/i.test(k);
      });

      return dynamicKey ? claim[dynamicKey] : null;
    },
    getDisbursalDateText(claim) {
      var rawDate = this.resolveDisbursalDate(claim);
      if (!rawDate) return "-";

      var formatted = this.convertDateFormat(rawDate);
      return formatted || "-";
    },
    normalizeClaimRow(claim) {
      if (!claim || typeof claim !== "object") return claim;

      var disbursalDate = this.resolveDisbursalDate(claim);

      return Object.assign({}, claim, {
        DisbursalDate: disbursalDate,
      });
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          this.selectedApplication.UserID +
          "/" +
          pic)
        );
      }
    },
    Add() {
      this.$router.push("/claimupload");
    },
    async viewDisbursal(item, index, target) {
      this.selectedApplication = item;
      this.formclm.ClaimID = item.ClaimEMIID;
      this.formclm.ApprovedAmount = item.ApprovedAmount;
      this.formclm.RejectedAmount = item.InterestAmt - item.ApprovedAmount;
      this.formclm.RejectReason = 0;
      this.formclm.Remarks = "";
      this.formclm.ClaimStatusID = item.ClaimStatusID;
      this.$root.$emit("bv::show::modal", "modalClaim");

      this.ApprovalStatus = _.filter(this.ApprovalStatusAll, {
        ClaimStatus: item.ClaimStatusID,
      });

      var statusTextAll = (
        (item && item.ClaimStatus ? item.ClaimStatus : "") + " " +
        (item && item.Status ? item.Status : "") + " " +
        (item && item.StatusName ? item.StatusName : "") + " " +
        (item && item.ApplicationStatus ? item.ApplicationStatus : "")
      ).toLowerCase();
      var isPmSendBackCase =
        statusTextAll.indexOf("send back by pm") !== -1 ||
        statusTextAll.indexOf("returned by pm") !== -1 ||
        statusTextAll.indexOf("send back") !== -1;
      // Scope this fallback to the roles that actually own the DM/Accounts
      // stage (ClaimStatus 1). Do NOT trigger it off form.StatusOwner alone —
      // that value can be stale/leftover from a previous queue view and was
      // incorrectly granting other roles (e.g. RM) a bogus "Send to Applicant"
      // action on claims that were never in their queue to begin with.
      // Claims the PM sent back land with their own ClaimStatusID (not 1), so
      // also match on the status text or the DM sees "No approval action".
      var isPmReturnedToDm =
        statusTextAll.indexOf("send back by pm") !== -1 ||
        statusTextAll.indexOf("returned by pm") !== -1;
      var isDmQueueContext =
        (this.RoleID === 2 || this.RoleID === 10) &&
        (item.ClaimStatusID === 1 || isPmReturnedToDm);

      // RM (RoleID 3) should be able to send a claim back to the DM.
      // Backend ReadClaimStatusByRole does not return this transition, so
      // inject a "Return to DM" option client-side whenever RM has any
      // approval action available on the current claim.
      if (this.RoleID === 3 && this.ApprovalStatus.length > 0) {
        let alreadyHasReturn = _.some(this.ApprovalStatus, function (s) {
          return (
            s &&
            typeof s.Status === "string" &&
            s.Status.toLowerCase().indexOf("return to dm") !== -1
          );
        });
        if (!alreadyHasReturn) {
          this.ApprovalStatus.push({
            StatusID: 1, // Pending => owned by DM again
            Status: "Return to DM",
            ClaimStatus: item.ClaimStatusID,
            ISReject: false,
          });
        }
      }

      // DM (RoleID 2/10): in some PM-returned claim cases backend transition
      // data misses the DM-stage actions. Fill them in from the master list.
      if (isDmQueueContext) {
        // A PM-returned claim has no DM-stage transitions of its own, so pull the
        // normal DM-stage ones (Approve / Reject) from the master list.
        if (isPmReturnedToDm) {
          var dmStageActions = _.filter(this.ApprovalStatusAll, { ClaimStatus: 1 });
          _.each(dmStageActions, (s) => {
            if (!_.some(this.ApprovalStatus, { StatusID: s.StatusID })) {
              this.ApprovalStatus.push(s);
            }
          });
          console.log("ApprovalStatusAll:", JSON.stringify(this.ApprovalStatusAll));
        }

        // The DM's Reject action sends the claim back to the applicant, who can
        // edit and resubmit it (a rejected claim is editable). Show that action
        // as "Send Back to Applicant for Edit" so the DM knows what it does.
        let isRealSendBack = function (s) {
          if (!s || typeof s.Status !== "string") return false;
          let t = s.Status.toLowerCase();
          return t.indexOf("send back") !== -1 && t.indexOf("applicant") !== -1;
        };
        if (!_.some(this.ApprovalStatus, isRealSendBack)) {
          let isRejectAction = function (s) {
            return s && typeof s.Status === "string" &&
              s.Status.toLowerCase().indexOf("reject") !== -1;
          };
          let rejectAction =
            _.find(this.ApprovalStatus, isRejectAction) ||
            _.find(this.ApprovalStatusAll, isRejectAction);
          let sendBackID = rejectAction ? rejectAction.StatusID : 6;
          this.ApprovalStatus = this.ApprovalStatus.filter(function (s) {
            return !s || s.StatusID !== sendBackID;
          });
          this.ApprovalStatus.push({
            StatusID: sendBackID,
            Status: "Send Back to Applicant for Edit",
            ClaimStatus: item.ClaimStatusID,
            ISReject: true,
          });
        }

        // Keep only one explicit Send Back option to avoid duplicates from mixed backend/client data.
        let seenSendBack = false;
        this.ApprovalStatus = this.ApprovalStatus.filter(function (s) {
          if (!s || typeof s.Status !== "string") return true;
          let statusText = s.Status.toLowerCase();
          let isSendBackApplicant =
            statusText.indexOf("send back") !== -1 &&
            statusText.indexOf("applicant") !== -1;
          if (!isSendBackApplicant) return true;
          if (seenSendBack) return false;
          seenSendBack = true;
          return true;
        });
      }

      console.log(JSON.stringify(item));
      if (this.ApprovalStatus.length > 0) {
        this.showApproval = true;
      } else {
        this.showApproval = false;
      }
      //(JSON.stringify(item));
      try {
        let promiseA = apis.ReadClaimApprovalRemarks(item.ClaimEMIID);

        var response = await promiseA;

        if (response.status == 200) {
          this.approvalRemarks = response.body;
        }
      } catch (err) {
        this.$dialog.alert("Error while Reading Approval Remarks");
      }
    },
    calculateReject(evt) {
      if (evt != "") {
        this.formclm.RejectedAmount = (
          this.selectedApplication.InterestAmt - parseFloat(evt)
        ).toFixed(2);
      }
    },
    calculateApprove(evt) {},
    onRowSelected(items) {
      this.selected = items;
    },
    checkReject(evt) {
      let id = parseInt(evt.target.value);
      let appStatus = _.filter(this.ApprovalStatus, { StatusID: id });
      if (appStatus) {
        if (appStatus.length > 0) {
          this.isReject = appStatus[0].ISReject;
          if (!this.isReject) {
            this.form.RejectReason = 0;
          }
        }
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getApprovalStatus() {
      let promise = apis.getClaimStatusMstr();
      promise
        .then((response) => {
          if (response.status == 200) {
            this.approvalStatus = response.body;
            this.approvalStatus.unshift({
              Id: 0,
              ApplicationStatus: "All",
            });
            //this.form.ClaimStatus = 0;
          } else {
            this.alertTextM =
              "Unable to Load Approval Status List, " + response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },

    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then((response) => {
          if (response.status == 200) {
            let allDistricts = response.body;

            // RM (RoleID 3) is scoped to their own division's districts only,
            // same mapping used in Applications.vue / ClaimsTable.vue.
            let loggedUser = this.$store.getters.loggedUser;
            if (loggedUser && loggedUser.RoleID === 3) {
              const divisionDistricts = {
                1: ['Mumbai City','Mumbai Suburban','Thane','Palghar','Raigad','Ratnagiri','Sindhudurg'],
                2: ['Pune','Kolhapur','Sangli','Satara','Solapur'],
                3: ['Nashik','Ahilyanagar','Dhule','Jalgaon','Nandurbar'],
                4: ['Chhatrapati Sambhajinagar','Beed','Parbhani','Jalna'],
                5: ['Latur','Dharashiv','Nanded','Hingoli'],
                6: ['Amravati','Akola','Buldhana','Yavatmal','Washim'],
                7: ['Nagpur','Bhandara','Wardha','Chandrapur','Gadchiroli','Gondia']
              };
              const allowedNames = divisionDistricts[loggedUser.RegistrationType];
              if (allowedNames) {
                allDistricts = allDistricts.filter(d => allowedNames.includes(d.DistName));
              }
            }

            this.districts = allDistricts;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All",
            });

            if (this.userDistrict != "00000000-0000-0000-0000-000000000000") {
              this.form.DistrictID = this.userDistrict;
            }
            this.isLoadingM = false;
            //this.$router.push("/");
          } else {
            this.alertTextM = response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
        })
        .catch((err) => {
          this.alertTextM = err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then((response) => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.banks = response.body;
            this.banks.unshift({
              BankID: "00000000-0000-0000-0000-000000000000",
              BankName: "All",
            });
            this.isLoadingM = false;
          } else {
            this.alertTextM = response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
        })
        .catch((err) => {
          this.alertTextM = err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then((response) => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
            this.form.LoanType = this.$store.getters.getLoanType;
          } else {
            this.alertTextM = "Unable to Load Scheme List, " + response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },
    getPaymentStatus() {
      let promise = apis.getPaymentStatusMstr();
      promise
        .then((response) => {
          if (response.status == 200) {
            this.paymentStatus = response.body;
            this.paymentStatus.unshift({ Id: 0, ApplicationStatus: "All" });
            this.form.ClaimPaidStatus = 0;
          } else {
            this.alertTextM =
              "Unable to Load Approval Status List, " + response.body;

            this.variantM = "warning";
            this.showDismissibleAlertM = true;
          }
          this.isLoadingM = false;
        })
        .catch((err) => {
          this.alertTextM =
            "Unable to Load Approval Status List, " + err.message;
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },

    onSubmitApprove(evt) {
      evt.preventDefault();
      let promise = apis.UpdateClaimStatus(this.formclm);

      promise
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            this.alertText = response.body;
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.isLoading = false;

            // If GM (RoleID 5) or MD (RoleID 4) approves (not reject), also update payment status to Paid
            if ((this.RoleID === 5 || this.RoleID === 4) && this.formclm.ClaimStatusID !== 6) {
              let paymentForm = {
                ClaimEMIID: this.formclm.ClaimID,
                ClaimPaymentStatus: "Paid",
                UserID: this.formclm.UserID
              };
              apis.UpdateClaimPayment(paymentForm)
                .then((payRes) => {
                  if (payRes.status == 200) {
                    console.log('Payment status updated to Paid');
                  } else {
                    console.log('Payment status update response:', payRes.body);
                  }
                  this.getDisbursals();
                })
                .catch((payErr) => {
                  console.error('Payment status update error:', payErr);
                  this.getDisbursals();
                });
            } else {
              this.getDisbursals();
            }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      if (this.isLoadingM) return;  // ignore extra clicks while loading
      this.getDisbursals();
    },

    getDisbursals() {
      if (this.isLoadingM) return;  // guard against concurrent calls
      this.isLoadingM = true;
      this.showDismissibleAlert = false;
      if (this.UpdateDate != null) {
        this.form.ClaimStartDate = Formatter.convertDateFormatYMD(
          this.UpdateDate[0]
        );
        this.form.ClaimEndDate = Formatter.convertDateFormatYMD(
          this.UpdateDate[1]
        );
      } else {
        this.form.ClaimStartDate = null;
        this.form.ClaimEndDate = null;
      }

      if (this.form.ClaimStatus == 4 || this.form.StatusOwner == "ToBePaid") {
        this.claims = [];
      }
      this.showxls = false;
      this.showExportButtons = false;

      // When StatusOwner is "ToBePaid", the backend filters by StatusOwner column which
      // does not match ClaimPaymentStatus. Send "All" to get all claims and filter client-side.
      var isToBePaidSearch = this.form.StatusOwner === 'ToBePaid';
      var searchForm = isToBePaidSearch ? Object.assign({}, this.form, { StatusOwner: 'All' }) : this.form;

      //let promise = apis.readAllClaims(this.form);
      let promise = apis.ReadClaimEMIForApproval(searchForm);

      promise
        .then((response) => {
          try {
            if (response.status == 200) {
              let loadedClaims = Array.isArray(response.body)
                ? response.body.map((claim) => this.normalizeClaimRow(claim))
                : [];

              var applyClientFilters = (claims) => {
                var filtered = Array.isArray(claims) ? claims.slice() : [];

                // Client-side filter for ToBePaid: backend doesn't handle this StatusOwner value,
                // so we filter the same way as the export: Approved claims not yet Paid.
                if (isToBePaidSearch) {
                  filtered = filtered.filter(function(claim) {
                    var payStatus = (claim.ClaimPaymentStatus || '').toString().trim().toLowerCase();
                    var claimSts = (claim.ClaimStatus || '').toString().trim().toLowerCase();
                    return claimSts === 'approved' && payStatus !== 'paid';
                  });
                }

                // Filter out rejected claims when viewing a specific role's approval queue
                // (Backend bug: when GM rejects, StatusOwner is incorrectly advanced to MD)
                var approvalQueues = ['Accounts', 'Auditor', 'DGM', 'GM', 'MD'];
                if (approvalQueues.indexOf(this.form.StatusOwner) !== -1) {
                  filtered = filtered.filter(function(claim) {
                    return !claim.ClaimStatus || claim.ClaimStatus.toLowerCase().indexOf('rejected') === -1;
                  });
                }

                return filtered;
              };

              var applyLoadedClaims = (claims) => {
                this.claims = sortClaimsFifo(applyClientFilters(claims));
                this.totalRows = this.claims.length;
                this.currentPage = 1;
                console.log('Claims loaded:', this.claims.length, 'StatusOwner:', this.form.StatusOwner);
                if (this.claims.length > 0) {
                  this.showExportButtons = true;
                  this.showxls = true;
                  console.log('showExportButtons set to:', this.showExportButtons);
                }
                // ApprovalLog will be populated lazily after main data renders
              };

              applyLoadedClaims(loadedClaims);
              this.$nextTick(() => this.loadApprovalLogs());
            } else {
              this.alertTextM = response.body || "Error loading claims";
              this.variantM = "warning";
              this.showDismissibleAlertM = true;
            }
          } catch (e) {
            this.alertTextM = e.message;
            this.variantM = "danger";
            this.showDismissibleAlertM = true;
          } finally {
            this.isLoadingM = false;
          }
        })
        .catch((err) => {
          this.alertTextM = err.message || "Network error";
          this.showDismissibleAlertM = true;
          this.variantM = "danger";
          this.isLoadingM = false;
        });
    },

    // Lazy-load approval log dates in the background after the table renders.
    // Uses small batches + delays so the main UI stays responsive.
    async loadApprovalLogs() {
      if (!this.claims || this.claims.length === 0) return;
      const BATCH = 5;
      const DELAY = 80; // ms between batches
      const snapshot = this.claims.slice();
      for (let i = 0; i < snapshot.length; i += BATCH) {
        const batch = snapshot.slice(i, i + BATCH);
        const results = await Promise.all(
          batch.map((claim) =>
            apis.ReadClaimApprovalRemarks(claim.ClaimEMIID)
              .then((res) => ({ id: claim.ClaimEMIID, data: res.status === 200 ? res.body : [] }))
              .catch(() => ({ id: claim.ClaimEMIID, data: [] }))
          )
        );
        results.forEach(({ id, data }) => {
          const idx = this.claims.findIndex((c) => c.ClaimEMIID === id);
          if (idx === -1) return;
          let log = '';
          if (data && data.length > 0) {
            const last = data[data.length - 1];
            log = last && last.LogDate ? Formatter.convertDateFormat(last.LogDate) : '';
          }
          this.$set(this.claims, idx, { ...this.claims[idx], _logLoading: false, ApprovalLog: log });
        });
        // Yield to the browser so UI stays responsive between batches
        await new Promise((resolve) => setTimeout(resolve, DELAY));
      }
    },

    onReset(evt) {
      evt.preventDefault();
      this.form = {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
      };
    },
    async confirmAndExport(format) {
      var confirmed = await this.$bvModal.msgBoxConfirm(
        'This will export the claims and mark them as Paid. Are you sure you want to continue?',
        {
          title: 'Warning',
          okVariant: 'warning',
          okTitle: 'Continue',
          cancelTitle: 'Cancel',
          centered: true
        }
      );
      if (confirmed) {
        if (format === 'text') {
          this.downloadCSV('ToBePaid');
        } else {
          this.downloadExcel('ToBePaid');
        }
      }
    },
    async downloadExcel(paymentStatus = 'Unpaid') {
      var columns = [
        "ClaimEMIID",
        "Sr. No.",
        "Full Name",
        "Aadhaar No",
        "District",
        "Sanction Amount",
        "Disbursed Amount",
        "Disbursal Date",
        "Total EMI Paid",
        "ROI%",
        "Tenure (months)",
        "EMI Paid Date",
        "EMI Paid Amt",
        "Principal Amt",
        "Interest Amt",
        "Penalty Charges",
        "Claim Status",
        "Payment Status",
        "Total Claim Amount",
        "Approved Amount",
        "Total Paid Claim",
        "Approval Log"
      ];
      let app_data = [];
      let n = 1;

      try {
          // Filter claims based on payment status
          let filteredClaims;
          if (paymentStatus === 'All') {
            filteredClaims = this.claims;
          } else if (paymentStatus === 'ToBePaid') {
            // Only include claims that are Approved AND NOT already Paid
            filteredClaims = this.claims.filter(claim => {
              var status = (claim.ClaimPaymentStatus || '').toString().trim().toLowerCase();
              var claimSts = (claim.ClaimStatus || '').toString().trim().toLowerCase();
              return status !== 'paid' && claimSts === 'approved';
            });
          } else {
            filteredClaims = this.claims.filter(claim =>
              claim.ClaimPaymentStatus && claim.ClaimPaymentStatus.toString().trim().toLowerCase() === paymentStatus.toLowerCase()
            );uil
          }

          if (filteredClaims.length === 0) {
            this.$dialog.alert('No claims found in the current list to export.');
            return;
          }

          filteredClaims.forEach((element) => {
            let obj = {
              "ClaimEMIID": element.ClaimEMIID,
              "Sr. No.": n,
              "Full Name": this.titleCase(element.FullName),
              "Aadhaar No": element.AdharNo || "",
              "District": element.DistrictName || "",
              "Sanction Amount": element.SanctionAmount,
              "Disbursed Amount": element.DisbursedAmount,
              "Disbursal Date": this.convertDateFormat(element.DisbursalDate),
              "Total EMI Paid": element.TotalEMIPaid,
              "ROI%": element.ROI,
              "Tenure (months)": element.LoanTenure,
              "EMI Paid Date": this.convertDateFormat(element.EMIPaidDate),
              "EMI Paid Amt": element.EMIPaidAmt,
              "Principal Amt": element.PrincipalAmt,
              "Interest Amt": element.InterestAmt,
              "Penalty Charges": element.PenaltyCharges,
              "Claim Status": element.ClaimStatus,
              "Payment Status": element.ClaimPaymentStatus,
              "Total Claim Amount": element.TotalClaimAmount,
              "Approved Amount": element.ApprovedAmount,
              "Total Paid Claim": element.TotalPaidClaim,
              "Approval Log": element.ApprovalLog || ""
            };
            app_data.push(obj);
            n++;
          });

          var vc = this;
          var wb = XLSX.utils.book_new();
          var ws = XLSX.utils.json_to_sheet(app_data, { header: columns });
          /*
          var ws = XLSX.utils.json_to_sheet(
            [
              {
                A: "                                                                                                                         MAHARASHTRA RAJYA ITAR MAGAS VARGIY VITTA ANI VIKAS MANDAL LTD",
                B: "",
                C: "",
                D: "",
                E: "",
                F: "",
                G: "",
                H: "",
                I: "",
                J: "",
              },
            ],
            {
              header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
              skipHeader: true,
            }
          );
          const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }];
          ws["!merges"] = merge;

          ws["A1"].s = {
            font: {
              sz: 12,
              bold: true,
              color: {
                rgb: "FFFFAA00",
              },
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrap_text: true,
            },
          };

          var d = new Date();
          XLSX.utils.sheet_add_json(
            ws,
            [
              {
                A: "",
                B: "",
                C: "",
                D: "",
                E: "",
                F: "",
                G: "",
                H: "",
                I: "Date:",
                J: d.toDateString(),
              },
            ],
            { skipHeader: true, origin: "A2" }
          );

          XLSX.utils.sheet_add_json(ws, app_data, {
            header: columns,
            origin: "A4",
          });
          */
          ws["!cols"] = [
            { wpx: 50 },   // Sr. No.
            { wpx: 150 },  // Full Name
            { wpx: 120 },  // Aadhaar No
            { wpx: 100 },  // Sanction Amount
            { wpx: 100 },  // Disbursed Amount
            { wpx: 100 },  // Disbursal Date
            { wpx: 100 },  // Total EMI Paid
            { wpx: 60 },   // ROI%
            { wpx: 100 },  // Tenure (months)
            { wpx: 100 },  // EMI Paid Date
            { wpx: 100 },  // EMI Paid Amt
            { wpx: 100 },  // Principal Amt
            { wpx: 100 },  // Interest Amt
            { wpx: 100 },  // Penalty Charges
            { wpx: 120 },  // Claim Status
            { wpx: 100 },  // Payment Status
            { wpx: 120 },  // Total Claim Amount
            { wpx: 120 },  // Approved Amount
            { wpx: 120 },  // Total Paid Claim
            { wpx: 150 }   // Approval Log
          ];
          const sheetName = `${paymentStatus}_Claims`;
          const fileName = `${paymentStatus}_Claims.xlsx`;
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
          XLSX.writeFile(wb, fileName);

          // If exporting ToBePaid claims, update all of them to Paid status
          if (paymentStatus === 'ToBePaid') {
            let claimids = filteredClaims.map(claim => claim.ClaimEMIID);
            apis.UpdateClaimPayment({
              UserID: this.formclm.UserID,
              ClaimIDs: claimids
            })
            .then((res) => {
              console.log('UpdateClaimPayment response:', res.status, res.body);
              this.getDisbursals();
              this.$dialog.alert(filteredClaims.length + ' claim(s) have been marked as Paid.');
            })
            .catch((err) => {
              console.error('Error updating payment status:', err);
              this.getDisbursals();
            });
          }
      } catch (err) {
        this.$dialog.alert("Error generating Excel file");
      }
    },

    async downloadCSV(paymentStatus = 'Unpaid') {
      try {
        // Filter claims based on payment status
        let filteredClaims;
        if (paymentStatus === 'All') {
          filteredClaims = this.claims;
        } else if (paymentStatus === 'ToBePaid') {
          // Only include claims that are Approved AND NOT already Paid
          filteredClaims = this.claims.filter(claim => {
            var status = (claim.ClaimPaymentStatus || '').toString().trim().toLowerCase();
            var claimSts = (claim.ClaimStatus || '').toString().trim().toLowerCase();
            return status !== 'paid' && claimSts === 'approved';
          });
        } else {
          filteredClaims = this.claims.filter(claim =>
            claim.ClaimPaymentStatus && claim.ClaimPaymentStatus.toString().trim().toLowerCase() === paymentStatus.toLowerCase()
          );
        }

        if (filteredClaims.length === 0) {
          this.$dialog.alert('No claims found in the current list to export.');
          return;
        }

        const rows = [];

        // Calculate total amount in paisa
        let totalAmountPaisa = 0;
        filteredClaims.forEach((element) => {
          const amt = parseFloat(element.ApprovedAmount || element.EMIPaidAmt || 0);
          totalAmountPaisa += Math.round(amt * 100);
        });

        // Format current date as DDMMYYYY
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yyyy = now.getFullYear();
        const dateStr = dd + mm + yyyy;

        // Total amount in paisa (13 digits)
        const totalStr = String(totalAmountPaisa).padStart(13, '0');

        // Header line (orange): bank code + batch + account + record count + total + date
        const headerLine = '33999ZN99VJNT                    0002     0005085410209010000500018                    00000001' + totalStr + dateStr;
        rows.push(headerLine);

        // Detail lines: 80 + Aadhaar (15 digits) + narration + sequence (4 digits) + amount in paisa (13 digits)
        filteredClaims.forEach((element, index) => {
          const aadhaar = String(element.AdharNo || '').replace(/\D/g, '').padStart(15, '0');
          const amt = parseFloat(element.ApprovedAmount || element.EMIPaidAmt || 0);
          const amtPaisa = String(Math.round(amt * 100)).padStart(13, '0');
          const seq = String(index + 2).padStart(4, '0');

          const line = '80        ' + aadhaar + '                 0005085419992N99Payment from VJNT  ' + seq + '      ' + amtPaisa;
          rows.push(line);
        });

        // Create and download text file
        const content = rows.join('\n');
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
        const link = document.createElement('a');

        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', `${paymentStatus}_Claims.txt`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // If exporting ToBePaid claims, update all of them to Paid status
        if (paymentStatus === 'ToBePaid') {
          let claimids = filteredClaims.map(claim => claim.ClaimEMIID);
          apis.UpdateClaimPayment({
            UserID: this.formclm.UserID,
            ClaimIDs: claimids
          })
          .then((res) => {
            console.log('UpdateClaimPayment response:', res.status, res.body);
            this.getDisbursals();
            this.$dialog.alert(filteredClaims.length + ' claim(s) have been marked as Paid.');
          })
          .catch((err) => {
            console.error('Error updating payment status:', err);
            this.getDisbursals();
          });
        }
      } catch (err) {
        console.error('Error generating text file:', err);
        this.$dialog.alert("Error generating text file");
      }
    },

    titleCase(str) {
      if ((str != null) & (str != undefined)) {
        return str
          .trim()
          .toLowerCase()
          .split(" ")
          .map(function (word) {
            if (word) {
              return word.replace(word[0], word[0].toUpperCase());
            } else {
              return "";
            }
          })
          .join(" ");
      }
    },
    //ReadClaimRejectionReason
  },
  // created() {
  //   var dt = new Date();
  //   var dtInMs = dt.getTime();
  //   dtInMs -= 60 * 1000 * 60 * 24 * 30; //30 Days
  //   dt.setTime(dtInMs);

  //   this.UpdateDate[0] = dt;
  //   this.UpdateDate[1] = new Date();
  // },
  mounted() {
    this.form.DistrictID = this.$store.getters.getDistrict;
    this.form.LoanType = this.$store.getters.getLoanType;
    this.form.ClaimStatus = 0;
    this.form.StatusOwner = this.$store.getters.getStatusOwner;

    var userinfo = this.$store.getters.loggedUser;
    this.RoleID = userinfo.RoleID;
    this.formclm.UserID = userinfo.UserId;

    // Start claim data load immediately (most expensive call)
    this.getDisbursals();

    // Fire all master-data calls in parallel — none depend on each other
    Promise.all([
      this.getApprovalStatus(),
      this.getPaymentStatus(),
      this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1"),
      this.getSchemes(),
      this.ReadBanks(),
      apis.ReadClaimStatusByRole({ RoleTypeID: this.RoleID })
        .then((r) => { if (r.status === 200) this.ApprovalStatusAll = r.body; })
        .catch(() => {}),
      apis.ReadClaimRejectionReason()
        .then((r) => { if (r.status === 200) this.RejectReasons = r.body; })
        .catch(() => {})
    ]).catch(() => {});
  },
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/ClaimList.vue